import React from 'react'
import { FooterComponent, NavbarComponent } from '../../SharedComponents'
import TitleSection from './TitleSection'
import './ProductPage.css'
import ProductDetailsSection from './ProductDetailsSection'
import MoreProductsSection from './MoreProductsSection'
import BackToNatureSection from '../SustainabilityPage/BackToNatureSection'

export default function ProductPage() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
    return (
        <div>
            <NavbarComponent />
            <TitleSection />
            <ProductDetailsSection />
            <MoreProductsSection />
            <BackToNatureSection />
            <FooterComponent />
        </div>
    )
}
